<template>
  <div>付款明细</div>
</template>

<script>
export default {
  name: 'index'
}
</script>

<style scoped>

</style>
